import {createUseQuery} from "@irati/utils/services/apollo"
import {BenefitContent, QueryBenefitsContentArgs} from "@irati/types"

import benefitsContentQuery, {benefitsContentKey} from "../services/queries/benefitsContent"

const useBenefitsContentQuery = createUseQuery<BenefitContent, QueryBenefitsContentArgs>(
  benefitsContentQuery,
  {
    key: benefitsContentKey
  }
)

export default useBenefitsContentQuery
